import sortBy from 'lodash/sortBy';
import { filter } from 'ramda';

export const sortTransactionsByDate = (txs) =>
  sortBy(txs, (tx) => {
    return tx.booking ? tx.booking.attributes.start : null;
  });

const userIsBannedOrDeleted = (user) => user.attributes.banned || user.attributes.deleted;

export const filterBannedUsers = (txs) =>
  filter((tx) => !(userIsBannedOrDeleted(tx.customer) || userIsBannedOrDeleted(tx.provider)), txs);
